import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'

export const MainContainer = styled(Box)(`
  display: flex;
  height: 100vh;
`)
export const RightSideContainer = styled(Box)(`
  display: flex;
  flex-direction: column;
  flex: 1;
`)
export const MiddleContainer = styled(Box)(`
  overflow-y: auto;
  height: calc(100vh - 56px);
`)

export const Container = styled(Box)(`
  min-height: calc(100vh - 106px);
  padding: 15px 20px;
`)
